<script>
import appConfig from "@/app.config";
import ExpiryUpdateAlert from "./redem/account/modals/expiry-update-alert.vue";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  components: { ExpiryUpdateAlert }
};
</script>

<template>
  <div id="app">
    <ExpiryUpdateAlert />
    <RouterView />
  </div>
</template>
